
export const MailchimpData = {
    "placeholder": "Introduce tu email",
    "submit": "Subscribirse!"
};